// Per-utterance bookkeeping. A final-only turn must not inherit a previous
// turn's delta flag; repeated provider events must not duplicate dictation.
export function createTranscriptTracker() {
  const turns = new Map();
  const seen = new Set();
  let anonymous = 0;
  function remember(id) {
    if (!id) return false;
    if (seen.has(id)) return true;
    seen.add(id);
    if (seen.size > 512) seen.delete(seen.values().next().value);
    return false;
  }
  return (event, completed) => {
    if (remember(event.event_id)) return null;
    const key = event.item_id ? `${event.item_id}:${event.content_index ?? 0}` : `anonymous:${anonymous}`;
    const turn = turns.get(key) || { text: '', done: false };
    if (turn.done) return null;
    if (!completed) {
      const delta = typeof event.delta === 'string' ? event.delta : event.text;
      if (typeof delta !== 'string' || !delta) return null;
      turn.text += delta;
      turns.set(key, turn);
      return { delta };
    }
    const transcript = String(event.transcript || event.text || turn.text).trim();
    const result = { transcript, hadDelta: !!turn.text };
    turns.set(key, { text: '', done: true });
    if (!event.item_id) anonymous += 1;
    if (turns.size > 128) turns.delete(turns.keys().next().value);
    return result;
  };
}
